<template>
  <button v-if="hasSelectedFilters" type="button" class="serp__filter--clear-button q-btn q-btn-sm q-btn-danger q-mb-3 q-rounded-3 q-shadow-sm"
          @click="filtersStore.clearSelectedFilters">
    {{ SmartSearchTranslations.filters.clear }}
  </button>
</template>
<script setup lang="ts">
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {toRefs, inject} from "vue";


const filtersStore = useFiltersStore()
const {hasSelectedFilters} = toRefs(filtersStore)
import { SmartSearchTranslationsInterface} from "@/core/types";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


</script>
<style>
.serp__filter--clear-button{
  max-width: 200px;
  margin: auto;
}
</style>